var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.theme === 'dark' ? 'LogoDark' : 'LogoLight',{tag:"component",style:("height: " + (_vm.$vuetify.breakpoint.mdAndUp ? _vm.height : _vm.height - 20) + "px;" + "")})}
var staticRenderFns = []

export { render, staticRenderFns }